import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';

import {
  GET_MEMBER_TRANSFER_STATUS_REQUEST,
  GET_MEMBER_TRANSFER_STATUS_SUCCESS,
  GET_MEMBER_TRANSFER_STATUS_FAILURE,
  COMMON_FAILURE,
} from '../../actions';
import { memberTransferStatusService } from '../../services';
import { historyType } from '../../../utils/commonType';

export type getMemberTransferAction = {
  type: typeof GET_MEMBER_TRANSFER_STATUS_REQUEST;
  memberNo: string;
  history: historyType;
};

function* getMemberTransferStatus(action: getMemberTransferAction): Generator<unknown> {
  try {
    const res: any = yield call(memberTransferStatusService(action).getMemberTransferStatus);
    yield put({
      type: GET_MEMBER_TRANSFER_STATUS_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_MEMBER_TRANSFER_STATUS_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchMemberTransferStatus() {
  yield takeLatest(GET_MEMBER_TRANSFER_STATUS_REQUEST, getMemberTransferStatus);
}

export default function* memberTransferStatusSaga(): Generator<unknown> {
  yield all([fork(watchMemberTransferStatus)]);
}
